import {debouncer, documentReady} from '../Utility/utils';

const hero = document.querySelector('.hero');
const vimeoBG = document.querySelector('.hero__vimeo_bg');

document.addEventListener('pageloaded', () => {
  if(!!hero && !!vimeoBG){
    set_hero_aspect_ratio_class();

    setTimeout(() => {
      set_hero_aspect_ratio_class();
    }, 1000);

    let heroResizeDebouncer;
    window.addEventListener('resize', () => {
      clearTimeout(heroResizeDebouncer);
      heroResizeDebouncer = setTimeout(() => {
        set_hero_aspect_ratio_class();
      })}, 50);
  }
});

const set_hero_aspect_ratio_class = () => {
  const height = hero.getBoundingClientRect().height;
  const width = hero.getBoundingClientRect().width;

  // Set properties to use for CSS sizing
  hero.style.setProperty('--hero-width', width + 'px');
  hero.style.setProperty('--hero-height', height + 'px');

  if(width / height < 1.777){
    vimeoBG.classList.add('vimeo_tall');
    vimeoBG.classList.remove('vimeo_wide');
  }
  else {
    vimeoBG.classList.add('vimeo_wide');
    vimeoBG.classList.remove('vimeo_tall');
  }
  
}